"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var StyleItem_1 = __importDefault(require("../StyleItem/StyleItem"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("DataStores/Account/Types");
var BlockStyleStore_1 = require("Project/Stores/BlockStyleStore");
var StyleLibrary = (function (_super) {
    __extends(StyleLibrary, _super);
    function StyleLibrary(props) {
        var _this = _super.call(this, props) || this;
        _this.searchValue = "";
        _this.setAppliedStyleId = function (styleId) {
            _this.appliedStyleId = styleId;
        };
        _this.handleSearchChange = function (searchValue) {
            _this.searchValue = searchValue;
        };
        _this.handleSearchClear = function () {
            _this.searchValue = "";
        };
        _this.handleAddStyle = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, blockStore, styleModalService, savedStyleService, blockStyleStore, trackCreateStyle, blockStyleModel, style;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, blockStore = _a.blockStore, styleModalService = _a.styleModalService, savedStyleService = _a.savedStyleService;
                        blockStyleStore = blockStore.blockStyleStore;
                        trackCreateStyle = savedStyleService.trackCreateStyle;
                        blockStyleModel = (0, BlockStyleStore_1.getNonSourceBlockStyle)(blockStyleStore);
                        return [4, styleModalService.showSaveModal(blockStyleModel)];
                    case 1:
                        style = _b.sent();
                        if (style) {
                            blockStyleModel.clonedFrom = style._id;
                            this.setAppliedStyleId(style._id);
                            trackCreateStyle(style, blockStore.blockType, blockStyleModel.clonedFrom);
                        }
                        return [2];
                }
            });
        }); };
        _this.appliedStyleId = props.blockStore.blockStyleStore.model.clonedFrom;
        return _this;
    }
    StyleLibrary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, savedStyleService, telemetry;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, savedStyleService = _a.savedStyleService, telemetry = _a.telemetry;
                        return [4, savedStyleService.getAllSavedStyles()];
                    case 1:
                        _b.sent();
                        telemetry.trackOnly("Block Styles Viewed", {}, {
                            blockIntercom: true,
                        });
                        return [2];
                }
            });
        });
    };
    StyleLibrary.prototype.render = function () {
        var _this = this;
        var appliedStyleId = this.appliedStyleId;
        var filteredStyles = this.getFilteredStyles();
        var _a = this.props, blockStore = _a.blockStore, styleModalService = _a.styleModalService, savedStyleService = _a.savedStyleService, telemetry = _a.telemetry, stylePermissionStore = _a.stylePermissionStore;
        return (react_1.default.createElement("div", { className: "saved-style saved-style--id-".concat(blockStore.$id) },
            react_1.default.createElement("div", { className: "saved-style__label saved-style__section" },
                react_1.default.createElement("div", null, "Block styles"),
                stylePermissionStore.allowStyle(Types_1.StyleAccessType.StyleLibrary) && (react_1.default.createElement(kaleidoscope_1.Tooltip, { autoStack: true, content: "Create new style" },
                    react_1.default.createElement(kaleidoscope_1.IconButton, { isRound: true, className: "saved-style__create-button", size: kaleidoscope_1.ButtonSize.Small, buttonState: kaleidoscope_1.ButtonState.Idle, type: kaleidoscope_1.ButtonType.Secondary, "aria-label": "Add style", icon: react_1.default.createElement(icons_1.Add, null), onClick: this.handleAddStyle })))),
            react_1.default.createElement("div", { className: "saved-style__search-section saved-style__section" },
                react_1.default.createElement(kaleidoscope_1.SearchInput, { onChange: this.handleSearchChange, onClear: this.handleSearchClear, size: kaleidoscope_1.TextInputSize.Small, value: this.searchValue, label: "Search styles", placeholder: "E.g. style" })),
            react_1.default.createElement("div", { className: "saved-style__list" }, !!filteredStyles.length &&
                filteredStyles.map(function (style, index) { return (react_1.default.createElement(StyleItem_1.default, { key: "".concat(style._id, "-").concat(index), isEditable: stylePermissionStore.allowStyle(Types_1.StyleAccessType.StyleLibrary), isApplied: appliedStyleId === style._id, setAppliedStyleId: _this.setAppliedStyleId, styleModalService: styleModalService, savedStyleService: savedStyleService, style: style, blockStore: blockStore, telemetry: telemetry, brandStore: _this.props.brandStore })); }))));
    };
    StyleLibrary.prototype.getFilteredStyles = function () {
        var _this = this;
        var _a = this.props, savedStyleService = _a.savedStyleService, blockStore = _a.blockStore;
        return savedStyleService.getSavedStylesByBlockType(blockStore.blockType).filter(function (style) {
            return style.name.toLowerCase().includes(_this.searchValue.toLowerCase());
        });
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], StyleLibrary.prototype, "appliedStyleId", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], StyleLibrary.prototype, "searchValue", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], StyleLibrary.prototype, "setAppliedStyleId", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], StyleLibrary.prototype, "handleSearchChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], StyleLibrary.prototype, "handleSearchClear", void 0);
    StyleLibrary = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], StyleLibrary);
    return StyleLibrary;
}(react_1.default.Component));
exports.default = StyleLibrary;
